<script lang="ts">
import { TypographyTags } from '@/utils/accessibility';
import { BuilderComponent } from '@/utils/cms';
import { fonts } from '@/utils/typography';

export const Header5Registration: BuilderComponent = {
  name: 'Header5',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Header 5 text here' } },
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
};
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    font?: 'sofia-pro' | 'gelica';
    headerTag?: TypographyTags;
  }>(),
  {
    font: 'sofia-pro',
    headerTag: 'h5',
  },
);
</script>

<template>
  <component
    :is="headerTag"
    class="text-base font-semibold leading-5 header-5 lg:text-xl lg:leading-6"
    :class="fonts[font]"
  >
    <slot />
  </component>
</template>

<style scoped>
.header-5 {
  @apply mb-0;
}
</style>
